import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, BuildingIcon, UserRoundIcon } from 'lucide-react';
import { SlideFrame } from '../SlideFrame';
import { BUSINESS_BENEFITS, CUSTOMER_BENEFITS } from '../../../data/deck';
const EASE = [0.23, 1, 0.32, 1] as const;
function BenefitColumn({
  eyebrow,
  heading,
  items,
  icon,
  active,
  offset,
  accent
}: {
  eyebrow: string;
  heading: string;
  items: string[];
  icon: React.ReactNode;
  active: boolean;
  offset: number;
  accent: 'indigo' | 'purple';
}) {
  return <div className="flex flex-col justify-center h-full px-10 py-8" data-id="element-1805" data-mp="168xkuamapqec">
      <div className="flex items-center gap-3" data-id="element-1806" data-mp="1kz4wa6dvy95j">
        <span className={`w-9 h-9 rounded-xl flex items-center justify-center ${accent === 'indigo' ? 'bg-primary-indigo/[0.08] text-primary-indigo' : 'bg-ai-purple/[0.10] text-ai-purple'}`} data-id="element-1807" data-mp="1kxtsw7ocr3ey">
          {icon}
        </span>
        <div data-id="element-1808" data-mp="1p21fnzb929aj">
          <p className="text-[9.5px] font-semibold uppercase tracking-[0.2em] text-slate-400" data-id="element-1809" data-mp="1oydm505t1mvt">
            {eyebrow}
          </p>
          <p className="font-display font-bold text-[19px] text-dark-navy leading-tight" data-id="element-1810" data-mp="1e1onvsenjbvn">
            {heading}
          </p>
        </div>
      </div>

      <ul className="mt-7 space-y-3.5" data-id="element-1811" data-mp="1j00029sf5yh1">
        {items.map((item, index) => <motion.li key={item} className="flex items-start gap-3" initial={{
        opacity: 0,
        x: -10
      }} animate={active ? {
        opacity: 1,
        x: 0
      } : {
        opacity: 0,
        x: -10
      }} transition={{
        duration: 0.4,
        ease: EASE,
        delay: offset + index * 0.07
      }} data-id="element-1812" data-mp="1o15s05e99hpi" data-mpi={index}>
            <span className={`mt-[3px] w-4 h-4 rounded-full flex items-center justify-center shrink-0 ${accent === 'indigo' ? 'bg-primary-indigo' : 'bg-ai-purple'}`} data-id="element-1813" data-mp="21satze53im30">
              <CheckIcon className="w-2.5 h-2.5 text-white" strokeWidth={3} data-id="element-1814" data-mp="2bo5kswjh3ngv" />
            </span>
            <span className="text-[13.5px] leading-snug text-slate-600" data-id="element-1815" data-mp="2fp7l7gp4m5kf">{item}</span>
          </motion.li>)}
      </ul>
    </div>;
}
export function SlideBenefits({
  active
}: {
  active: boolean;
}) {
  return <SlideFrame eyebrow="Benefits" title="Value for businesses. Better experience for customers." lead="One conversational layer, two sides of the same result." data-id="element-1816" data-mp="pevod5crf52u">
      <div className="relative h-full flex items-stretch" data-id="element-1817" data-mp="kmkqs95hrvdg">
        <motion.div className="relative grid grid-cols-2 w-full rounded-3xl bg-white border border-slate-100 overflow-hidden" style={{
        boxShadow: '0 26px 70px -34px rgba(11,18,32,0.28)'
      }} initial={{
        opacity: 0,
        y: 18
      }} animate={active ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 18
      }} transition={{
        duration: 0.5,
        ease: EASE,
        delay: 0.18
      }} data-id="element-1818" data-mp="zbqkxiph2veh">
          <BenefitColumn eyebrow="For businesses" heading="Sell better, not louder" items={BUSINESS_BENEFITS} icon={<BuildingIcon style={{
          width: 18,
          height: 18
        }} data-id="element-1820" data-mp="2w02xdd3m24sa" />} active={active} offset={0.3} accent="indigo" data-id="element-1819" data-mp="3a5v229s54338" />
          <span className="absolute left-1/2 top-8 bottom-8 w-px bg-slate-100" aria-hidden="true" data-id="element-1821" data-mp="300mre7sw0sa7" />
          <div className="bg-slate-50/60" data-id="element-1822" data-mp="2m9rgkpytw13z">
            <BenefitColumn eyebrow="For customers" heading="Ask once, get answers" items={CUSTOMER_BENEFITS} icon={<UserRoundIcon style={{
            width: 18,
            height: 18
          }} data-id="element-1824" data-mp="2cairobitlcoh" />} active={active} offset={0.42} accent="purple" data-id="element-1823" data-mp="2r8uiw2nfbt89" />
          </div>
        </motion.div>
      </div>
    </SlideFrame>;
}